module.exports = __webpack_public_path__ + "img/speaker_6.f0af0152.jpg";